import React from "react";
import { connect } from "react-redux";

import PageView2 from "./PageView2";
import { childrenPageViews } from "./pages";
import {
  resetOrgData,
  logoutFromBlumira,
  navigateToDefault,
} from "../redux/actions/Page";

import { CircularProgress } from "@material-ui/core";
import logo from "../images/blumira_login_blue.png";

const NOOP = () => <div />;

const mapStateToProps = (state) => {
  const pageConfig = childrenPageViews.find(
    (pg) =>
      pg.route ===
      `${state.location.payload.toplevel}/${state.location.payload.secondlevel}`
  );
  const ChildView = pageConfig ? pageConfig.component : NOOP;

  // evaluate top level navigation string to compare against
  // areas restricted by launchdarkly
  const locationTopLevel = state.location.payload.toplevel;

  return {
    ChildView,
    locationTopLevel,
    loading: state.page.loading, // do not drill
  };
};

const mapDispatchToProps = (dispatch, getState) => ({
  handleNavigateToDefault: () => {
    dispatch(navigateToDefault);
  },
  routeToOrg: (props) => {
    dispatch(resetOrgData);
    dispatch({ type: props.type, payload: props.payload, query: props.query });
  },
  routeToPage: (props) => {
    dispatch({ type: "PAGE", ...props });
  },
  routeToLogin: () => {
    dispatch(logoutFromBlumira);
  },
  dispatch,
  applyFilter: (filterKey, filterObj) => {
    dispatch({ type: "PAGE_FILTER", filterKey, filterObj });
  },
});

const PageViewWrapper = (props) => {
  if (props.loading) {
    return (
      <div className="h-100 w-100 d-flex align-items-center loading">
        <div className="row mx-auto align-items-center">
          <div className="col align-items-center mx-auto">
            <img className="mx-auto" src={logo} alt="Logo" title="Blumira" />
            <CircularProgress size={35} />
            <h2>Loading...</h2>
          </div>
        </div>
      </div>
    );
  } else {
    return <PageView2 ChildView={props.ChildView} dispatch={props.dispatch} />;
  }
};

export default connect(mapStateToProps, mapDispatchToProps)(PageViewWrapper);
